/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_SubmissionsInputs */

const en_landing_pricing_compare_submissions = /** @type {(inputs: Landing_Pricing_Compare_SubmissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool submissions`)
};

const zh_landing_pricing_compare_submissions = /** @type {(inputs: Landing_Pricing_Compare_SubmissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具提交`)
};

/**
* | output |
* | --- |
* | "Tool submissions" |
*
* @param {Landing_Pricing_Compare_SubmissionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_submissions = /** @type {((inputs?: Landing_Pricing_Compare_SubmissionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_SubmissionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_submissions(inputs)
	return zh_landing_pricing_compare_submissions(inputs)
});
export { landing_pricing_compare_submissions as "landing.pricing.compare_submissions" }